import React from "react";

// NOTE: This provider previously imported `PermissionContext` from
// "@amzn/msa-static-website-development", but that package never exported it
// (only Notes, ProgramDetail, featureReducers, rootSaga). The import resolved
// to `undefined`, so `<PermissionContext.Provider>` threw at runtime on any
// system page. Nothing in the app consumes the context either — permission
// checks go through the `usePermission()` Redux hook directly — so the provider
// is a pass-through. If cross-package permission context is needed later, the
// context must live in a shared package that both the UI app and the
// development package can import.
export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};
